
























import { isEqual } from 'lodash'
import Vue from 'vue'
import { Component, Emit, Prop } from 'vue-property-decorator'

@Component({
  data() {
    return {
      isEqual
    }
  }
})
export default class DefaultValueWrapper extends Vue {
  @Prop() isValueReset!: boolean

  @Prop({ type: Boolean, required: true }) defaultValueActive!: boolean

  @Prop({ type: Boolean, default: false, required: false }) defaultValueWrapper!: boolean

  @Prop({ type: String, required: false }) buttonTitle!: string

  @Prop() disabled!: boolean

  @Emit()
  onSettingClick() {
    return true
  }
}
